// import axios from "axios";
import { unrouteinstance as axios } from '../untils/http'
import { createSlice, createAsyncThunk,PayloadAction} from "@reduxjs/toolkit";
interface UserState {
  loading: boolean;
  error: string | null;
  token: string | null;
}

const initialState: UserState = {
  loading: false,
  error: null,
  token: null,
};

export const signIn = createAsyncThunk(
  "user/signIn",
  async (paramaters: {
      userid: string,
      password: string,
  }, thunkAPI)=>{
    const  response = await axios.post(
      `/account/login`,{
        userName: paramaters.userid,
        password: paramaters.password
      }
    )
    if(response.status === 200){
      if(response.data.isMFAVerificationNeeded === true) {
        localStorage.setItem("tempauthtoken" , response.data.token);
        localStorage.setItem("userid" , response.data.userID);
        var role1 = JSON.parse(window.atob(localStorage.getItem('tempauthtoken').split('.')[1]))["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
        localStorage.setItem("userrole" , role1);
      }else {
        localStorage.removeItem('tempauthtoken');
        localStorage.setItem("authtoken" , response.data.token);
        localStorage.setItem("userid" , response.data.userID);
        var role = JSON.parse(window.atob(localStorage.getItem('authtoken').split('.')[1]))["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
        localStorage.setItem("userrole" , role);
      }
    }
    
    return response.data;
  }
)

export const forgotpass = createAsyncThunk(
  "user/forgotpass",
  async (paramaters: {
      userid: string,
      email: string,
  }, thunkAPI)=>{
    const  response = await axios.post(
      `/Account/forgotpassword`,{
        // headers : {
        //   'Authorization': 'Bearer ' + user.token
        // },
        userID: paramaters.userid,
        email: paramaters.email
      }
    )
  }
)

export const userSlice = createSlice({
  name:'user',
  initialState,
  reducers:{
    logOut: (state) => {
      state.token = null;
      state.error = null;
      state.loading = false;
    },
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload
    },
  },
  extraReducers: {
    [signIn.pending.type]: (state) => {
      state.loading = true;
    },
    [signIn.fulfilled.type]: (state, action) => {
      state.token = action.payload;
      state.loading = false;
      state.error = null;
    },
    [signIn.rejected.type]: (state, action: PayloadAction<string | null>) => {
      state.loading = false;
      if(action.payload) {
        state.error = action.payload;
      } else {
        state.error = 'Failed user to login';
      }
    },
    [forgotpass.pending.type]: (state) => {
      state.loading = true;
    },
    [forgotpass.fulfilled.type]: (state, action) => {
      state.token = action.payload;
      state.loading = false;
      state.error = null;
    },
    [forgotpass.rejected.type]: (state, action: PayloadAction<string | null>) => {
      state.loading = false;
      state.error = action.payload;
    },
  }
})

export const { setLoading } = userSlice.actions
export default userSlice.reducer;